<template>
  <div class="home-box">
    <v-progress-linear v-if="loading" indeterminate color="orange"></v-progress-linear>
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2">Activity List</h3>
        <v-spacer></v-spacer>
        <AutocompleteSearch @changeData="clubId = $event" :storeLink="'member/getRoleClubs'" :setectVale="clubId"
          :itemText="'name'" :label="'Select Club'" />
        <v-spacer></v-spacer>
        <v-autocomplete :items="months" auto-select-first rounded outlined dense hide-details hide-selected
          :item-text="'name'" :item-value="'id'" label="Month" v-model="month"></v-autocomplete>
      </v-card-title>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="12" md="12" sm="12">
          <v-list v-if="!loading">
            <v-list-item v-for="(item, index) in list" :key="index"
              @click="manageTasks(item.status, item.uuid, item.key)">
              <v-list-item-action>
                <v-icon v-if="item.status == 'SUBMITTED'" large
                  :color="getStatusColor(item.status)">mdi-checkbox-marked-circle-outline</v-icon>
                <v-icon v-else-if="item.status == 'PENDING'" large
                  :color="getStatusColor(item.status)">mdi-information</v-icon>
                <v-icon v-else-if="item.status == 'APPROVED'" large
                  :color="getStatusColor(item.status)">mdi-checkbox-marked-circle</v-icon>
                <v-icon v-else large :color="getStatusColor(item.status)">mdi-information</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.activity }}</v-list-item-title>
                <v-list-item-subtitle>Due: {{ item.due_date }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-chip small class="ma-1" dark :color="getStatusColor(item.status)">
                  {{ item.status || "Not Submitted" }}
                </v-chip>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-list v-if="!list">
            <v-list-item-content>
              <v-list-item-title>Activity not found!</v-list-item-title>
            </v-list-item-content>
          </v-list>
        </v-col>
      </v-row>
    </v-card>
    <Snackbars :text="successMsg" :snackbar="snackbar" color="orange" @classSnackbar="closeSnackbar" />
  </div>
</template>

<script>
import MonthsList from "@/utility/months.json";
import moment from "moment";
import { ActivityService } from "../../services/activity-service";
import { checkError } from "@/config/errors.js";
import Snackbars from "@/components/shared/Snackbars";
import AutocompleteSearch from "@/components/shared/AutocompleteSearch";

export default {
  name: "ActivityList",
  components: { Snackbars, AutocompleteSearch },

  data: function () {
    return {
      loading: false,
      filterBtnTTip: false,
      month: "",
      months: MonthsList,
      list: [],
      clubId: "",
      role: localStorage.getItem("role"),
      errors: null,
      successMsg: "",
      snackbar: false,
    };
  },

  mounted() {
    this.getCurrentMonth();
    this.$store.dispatch("auth/getProfile");

    localStorage.removeItem("maf_contribution_uuid");
    localStorage.removeItem("mjf_contribution_uuid");
    localStorage.removeItem("service_project_uuid");
    if (this.role == 'CLUB_PRESIDENT' || this.role == 'CLUB_SECRETARY' || this.role == 'CLUB_TREASURER' || this.role == 'CLUB_ADMINISTRATOR') {
      localStorage.removeItem("activity_club");
      this.clubId = localStorage.getItem("club_id");
    } else {
      this.clubId = localStorage.getItem("activity_club") ?? localStorage.getItem("club_id");
      localStorage.setItem("activity_club", this.clubId);
    }

  },

  watch: {
    month(val) {
      localStorage.setItem("activity_month", val);
      this.loadTaskList();
    },
    clubId(val) {
      if (this.role !== 'CLUB_PRESIDENT' && this.role !== 'CLUB_SECRETARY' && this.role !== 'CLUB_TREASURER' && this.role !== 'CLUB_ADMINISTRATOR') {
        localStorage.setItem("activity_club", val);
      }
      this.loadTaskList();
    }
  },

  methods: {
    getStatusColor(status) {
      let bgColor = "";

      switch (true) {
        case status === "SUBMITTED":
          bgColor = "blue";
          break;

        case status === "PENDING":
          bgColor = "pink";
          break;

        case status === "APPROVED":
          bgColor = "green";
          break;

        case status === "REJECTED":
          bgColor = "red";
          break;
        default:
          bgColor = "orange";
          break;
      }
      return bgColor;
    },

    loadTaskList() {
      if (this.clubId && this.month) {
        this.loading = true;
        ActivityService.getActivityList(this.month, this.clubId)
          .then((response) => {
            this.loading = false;
            if (response.data) {
              this.list = response.data;
            }
          })
          .catch((error) => {
            this.loading = false;
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
            this.list = [];
          });
      }

    },

    manageTasks(status, mAId, key) {

      if (status === "SUBMITTED" || status === "APPROVED") {
        this.$router.push("/activities/monthly/view/" + mAId + "/" + this.month + '/' + key);
      } else {
        this.redirectTasksManager(status, mAId, key);
      }
    },

    closeSnackbar() {
      this.snackbar = false;
    },

    getCurrentMonth() {
      if (localStorage.getItem('activity_month')) {
        this.month = localStorage.getItem('activity_month');
      } else {
        this.month = moment().format("MM");
      }

      this.loadTaskList();
    },

    redirectTasksManager(status, mAId, key) {
      this.snackbar = false;
      if (status === "PENDING" || status === "REJECTED") {
        this.$router.push("/activities/monthly/view/" + mAId + "/" + this.month + '/' + key);
      }
      else {
        this.$router.push("/activities/monthly/add/" + this.month + '/' + key);
      }
    },
  },
};
</script>
